module.exports = __webpack_public_path__ + "static/playbook-cover-b07c48dec8c92761feeef2d0b91a8ead.png";